/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { lodash } from '@ba-ui-toolkit/utils';
import { Collapse as RCollapse, UnmountClosed } from 'react-collapse';

const { omit } = lodash;

export default class Collapse extends Component {
	static propTypes = {
		autoUnmount: PropTypes.bool,
		...RCollapse.propTypes,
	};

	static defaultProps = {
		autoUnmount: false,
	};

	render() {
		const { isOpened, autoUnmount } = this.props;

		const passThroughProps = { ...omit(this.props, 'autoUnmount') };

		return autoUnmount ? (
			<UnmountClosed {...passThroughProps} aria-expanded={isOpened} role="region" />
		) : (
			<RCollapse {...passThroughProps} aria-expanded={isOpened} role="region" />
		);
	}
}
